import React, { PureComponent } from 'react';
import { GenericAlert } from "com-gyf-webcore-userinterfacecomponents";
import Title from './Title.jsx';
import InputDataAccount from './InputDataAccount.jsx';
import SelectProduct from './SelectProduct.jsx';
import SelectBranch from './SelectBranch.jsx';
import LabelPortfolio from './LabelPortfolio.jsx';
import SelectPurchaseLimit from './SelectPurchaseLimit.jsx';
import RadioButtonLimits from './RadioButtonLimits.jsx';
import InputLimit from './InputLimit.jsx';
import RadioButtonGroup from './RadioButtonGroup.jsx';
import RadioButtonPayMethod from './RadioButtonPayMethod.jsx';
import SelectDomicilioCorrespondencia from './SelectDomicilioCorrespondencia.jsx';
import SelectDomicilioParticular from './SelectDomicilioParticular.jsx';
import InputAutoCompletePromotor from './InputAutoCompletePromotor.jsx';
import InputSalesChannel from './InputSalesChannel.jsx';
import RadioButtonLineOfCredits from './RadioButtonLineOfCredits.jsx';
import SelectBankCachier from './SelectBankCachier.jsx';
import ButtonAdd from './ButtonAdd.jsx';
import { Redirect, Link } from 'react-router-dom';
import ProcessManager from '../../../Common/Managers/ProcessManager.js';
import { createForm } from 'rc-form';

const GenericAlertWrapper = ({ error }) => {
    if (!error)
        return null;

    return <GenericAlert message="Por favor complete todos los campos" type="danger" />;
}

const LoadingIcon = ({ cambiaProducto }) => {

    if (!cambiaProducto)
        return null;

    return <div className="loading"> Loading &#8230;</div>;
}

class Cuenta extends PureComponent {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const idCuenta = this.props.match.params.id;
        this.props.GetScreenData(this.props.currentScope, idCuenta);
    }

    componentWillUnmount() {
        this.props.reiniciarEstado();
    }

    render() {

       const {
         form,
         data,
         tarjetas,
         guardarCampoCuenta,
         seleccionarCombo,
         selectComboProducto,
         validarCuenta,
         cancelar,
         actualizarEstadoGlobal
       } = this.props;

       const {
           volverASolicitud,
           dataFetched,
           cambiaProducto,
           domicilio,
           Cuenta,
           ValidarPantalla,
           Validaciones,
           GET_LIMITE_COMPRA,
           GET_MODELO_LIQUIDACION,
           GET_GRUPO_AFINIDAD,
           GET_SUCURSAL,
           GET_MODALIDAD_DISTRIBUCION_LIMITE,
           GET_AGRUPAMIENTO,
           GET_CODIGO_GEOGRAFICO,
           GET_TODOS_DOMICILIOS_ITAU,
           GET_DOMICILIOS_ITAU,
           GET_PRODUCTOS
       } = data;

       if (volverASolicitud == true) {
          return <Redirect to={ProcessManager.GetNextStep("Cuenta", "ROUTE_TO_CUENTA")} push />;
       }

       if (dataFetched == false) {
          return <div className="loading"> Loading &#8230;</div>;
       }

       return (
       <form id="bloqueoUsuario" className="top-separator-xs">

          <div className="container-fluid container-fluid-bordered">

              <Title Id={Cuenta.Id} />

              <LoadingIcon cambiaProducto={cambiaProducto} />
              
              <label className="label-secondary bottom-separator-xs">
               Recuerde que la nueva cuenta se creará solo si efectivamente la selecciona para dar de alta tarjetas y la solicitud en conjunto es aprobada.
              </label>

             <ButtonAdd cuenta={Cuenta} key="BUTTON_HEADER" cancelar={cancelar} validarCuenta={validarCuenta} />

             <GenericAlertWrapper error={ValidarPantalla} />
   
             <SelectProduct
                 Validaciones={Validaciones}
                 ValidarPantalla={ValidarPantalla}
                 ProductoId={Cuenta.ProductoId}
                 selectComboProducto={selectComboProducto}
                 GET_PRODUCTOS={GET_PRODUCTOS}
             />

             <InputDataAccount
                tarjetas={tarjetas}
                guardarCampoCuenta={guardarCampoCuenta}
                Validaciones={data.Validaciones}
                ValidarPantalla={data.ValidarPantalla}
                Cuenta={data.Cuenta}
                EsEdicion={data.EsEdicion}
             />

             <SelectBranch
                Cuenta={Cuenta}
                Validaciones={Validaciones}
                ValidarPantalla={ValidarPantalla}
                GET_MODELO_LIQUIDACION={GET_MODELO_LIQUIDACION}
                GET_GRUPO_AFINIDAD={GET_GRUPO_AFINIDAD}
                GET_SUCURSAL={GET_SUCURSAL}
                seleccionarCombo={seleccionarCombo}
             />

             <SelectPurchaseLimit
                 Validaciones={Validaciones}
                 ValidarPantalla={ValidarPantalla}
                 GET_LIMITE_COMPRA={GET_LIMITE_COMPRA}
                 Cuenta={Cuenta}
                 tarjetas={tarjetas}
                 seleccionarCombo={seleccionarCombo}
             />
             
             <RadioButtonLimits
                Validaciones={Validaciones}
                ValidarPantalla={ValidarPantalla}
                GET_MODALIDAD_DISTRIBUCION_LIMITE={GET_MODALIDAD_DISTRIBUCION_LIMITE}
                Cuenta={Cuenta}
                tarjetas={tarjetas}
                guardarCampoCuenta={guardarCampoCuenta}
             />
             
             <InputLimit form={form} Cuenta={data.Cuenta} edicion={data.edicion} guardarCampoCuenta={guardarCampoCuenta} />

             <LabelPortfolio tarjetas={tarjetas} />

             <RadioButtonGroup
                Validaciones={Validaciones}
                ValidarPantalla={ValidarPantalla}
                GET_AGRUPAMIENTO={GET_AGRUPAMIENTO}
                Cuenta={Cuenta}
                guardarCampoCuenta={guardarCampoCuenta}
              />

              <RadioButtonPayMethod data={data} tarjetas={tarjetas} guardarCampoCuenta={guardarCampoCuenta} seleccionarCombo={seleccionarCombo} />

              <SelectDomicilioCorrespondencia
                  Validaciones={Validaciones}
                  ValidarPantalla={ValidarPantalla}
                  GET_CODIGO_GEOGRAFICO={GET_CODIGO_GEOGRAFICO}
                  GET_TODOS_DOMICILIOS_ITAU={GET_TODOS_DOMICILIOS_ITAU}
                  Cuenta={data.Cuenta}
                  form={form}
                  guardarCampoCuenta={guardarCampoCuenta}
                  seleccionarCombo={seleccionarCombo}
              />

              <SelectDomicilioParticular
                  GET_CODIGO_GEOGRAFICO={GET_CODIGO_GEOGRAFICO}
                  domicilio={GET_DOMICILIOS_ITAU}
                  Validaciones={Validaciones}
                  ValidarPantalla={ValidarPantalla}
                  Cuenta={Cuenta}
                  form={form}
                  guardarCampoCuenta={guardarCampoCuenta}
              />

              <InputAutoCompletePromotor
                  GET_PROMOTOR={data.GET_PROMOTOR}
                  Cuenta={data.Cuenta}
                  guardarCampoCuenta={guardarCampoCuenta}
                  seleccionarCombo={seleccionarCombo}
                  Validaciones={Validaciones}
                  ValidarPantalla={ValidarPantalla}
              />
               
              <InputSalesChannel Cuenta={data.Cuenta} guardarCampoCuenta={guardarCampoCuenta} />

              <RadioButtonLineOfCredits
                 Cuenta={data.Cuenta}
                 GET_LINEA_PRESTAMO={data.GET_LINEA_PRESTAMO}
                 guardarCampoCuenta={guardarCampoCuenta}
              />
              
              <SelectBankCachier
                  Validaciones={data.Validaciones}
                  ValidarPantalla={ValidarPantalla}
                  Cuenta={Cuenta}
                  GET_CATEGORIA_CAJERO={data.GET_CATEGORIA_CAJERO}
                  seleccionarCombo={seleccionarCombo}
              />

              <ButtonAdd cuenta={Cuenta}  key="BUTTON_FOOTER" cancelar={cancelar} validarCuenta={validarCuenta} />

          </div>
            
        </form>
        );
    }
}

export default createForm()(Cuenta);